import React from 'react';
import classNames from 'classnames';
import { Field } from 'redux-form';
import { createProjectRequest } from 'pap/ducks/project';

class PAPQuestionBase extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showFieldHelp: false
    }
    this.toggleHelp = this.toggleHelp.bind(this);
  }

  toggleHelp(event) {
    event.preventDefault();
    this.setState({
      showFieldHelp: !this.state.showFieldHelp
    })
  }

  render() {
    const { input, name, stepTitle, stepDescription, stepHelp, stepNumber, stepCount } = this.props;
    const wide = name === "package" ? true : false;
    const classes = classNames(
      "transition-item", "pap-form-step", `step-${(name || '').replace('_', '-')}`,
      {
        "no-transition": this.props.fullScreen !== null,
        "wide": wide,
      }
    );

    const columnSize = wide ? "" : "medium-14 medium-offset-1 large-10 large-offset-3"
    /* augment validate functions by passing `stepName` as a prop */
    const validate = (this.props.fieldValidate || []).map(f => (
      (value, allValues, props) => f(value, allValues, {...props, stepName: name})
    ));

    return (
      <div className={classes}>
        <div className="row">
          <div className="columns small-16">
            <div className="pap-form-field" key={name}>
              <div className="row">
                <div className={classNames("columns",  columnSize )}>
                  <div className="pap-question-header">
                    {!this.props.simplified &&
                    <span className="pap-step-counter show-for-small-only">{ stepNumber } of { stepCount }</span>}

                    <h2 className="pap-field-label">{ stepTitle }</h2>
                    <p className="pap-field-description">
                      { stepDescription }
                      {this.state.showFieldHelp &&
                      <span className="pap-field-help">
                        &nbsp;<span dangerouslySetInnerHTML={{ __html: stepHelp }}/>
                        <a href="#" className="pap-field-help-toggle" onClick={this.toggleHelp}> Less</a>
                      </span>}
                      {!this.state.showFieldHelp && !!stepHelp &&
                      <a href="#" className="pap-field-help-toggle" onClick={this.toggleHelp}> More</a>}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className={classNames("columns",  columnSize )}>
                  <Field
                    name={name}
                    component={this.props.component}
                    options={this.props.options}
                    stepTitle={stepTitle}
                    stepDescription={stepDescription}
                    stepHelp={stepHelp}
                    validate={validate}
                    defaultValue={this.props.multiValue ? [] : ""}
                    {...this.props} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default PAPQuestionBase



// WEBPACK FOOTER //
// ./pap/components/common/pap_question_base.jsx